import { send } from '../../../../../src/network';
import { type PairingDetail } from '../../../../../src/types/PairingDetail';

export type GetPairingParam = {
  id: number;
  inventory_date?: string;
  origin?: number;
};

export function getPairingPath({
  id,
  inventory_date,
  origin,
}: GetPairingParam) {
  const queryParams = new URLSearchParams();

  if (origin !== undefined) {
    queryParams.append('origin', origin.toString());
  }

  if (inventory_date !== undefined) {
    queryParams.append('inventory_date', inventory_date.toString());
  }

  return `/api/v2/pairings/${id}/?${queryParams.toString()}`;
}

export async function getPairing({
  id,
  inventory_date,
  origin,
}: GetPairingParam) {
  return await send<PairingDetail>({
    path: getPairingPath({ id, inventory_date, origin }),
    method: 'GET',
  });
}
